<template>
  <div>
    <div class="modal is-active">
      <div @click="close" class="modal-background"></div>
      <div class="modal-content">
        <div class="card">
          <div class="card-content">
            <div class="content">
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input class="input" type="text" v-model="preference.name" placeholder="name">
                </div>
              </div>
              <div class="field">
                <label class="label">Keyword</label>
                <div class="control">
                  <input class="input" type="text"
                         v-model="preference.keyword"
                         placeholder="keyword">
                </div>
              </div>
              <div class="field">
                <label class="label">Category</label>
                <div class="control">
                  <select class="select" v-model="preference.parent_id">
                    <option v-for="(pref, key) in preferences" :key="key" :value="pref.id">{{ pref.name }}</option>
                    <option :value="null">No parent</option>
                  </select>
                </div>
              </div>
              <MetadataEditor v-model="preference.metadata" />

              <div class="field">
                <p class="control">
                  <button @click="createPreference" class="button is-success">
                    Update
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button @click="close" class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import {updatePreference} from "../../api/api";
import MetadataEditor from "./MetadataEditor";

export default {
  props: ['preferences', 'pref'],
  components: { MetadataEditor },
  data() {
    return {
      preference: {
        name: '',
        keyword: '',
        parent_id: null,
        archived: this.preferences?.archived,
        metadata: {}
      }
    }
  },
  methods: {
    close() {
      this.$emit("close")
    },
    async createPreference() {
      console.log(this.pref.id, this.preference)
      try {
        await updatePreference(this.pref.id, this.preference)
        this.$emit('preferences:updated')
        this.close()
      } catch (e) {
        console.error(e)
      }
    }
  },
  created() {
    this.preference.keyword = this.pref.keyword
    this.preference.name = this.pref.name
    this.preference.parent_id = this.pref.parent_id
    this.preference.metadata = this.pref.metadata ? JSON.parse(JSON.stringify(this.pref.metadata)) : {}
  }
}
</script>
